import React, {
	useState,
	useRef,
	useImperativeHandle,
	forwardRef,
	useEffect,
} from "react";
import DrawingCanvas from "../../../Reuniones/DrawingCanvas";
import { socket } from "../../../../../socket/socketClient";

const CanvasUploader = forwardRef(
	({ meetingId, remoteLines = [], setRemoteLines }, ref) => {
		const [includeCanvas, setIncludeCanvas] = useState(false);
		const canvasRef = useRef();

		useImperativeHandle(ref, () => ({
			isIncluded: includeCanvas,
			getCanvasRef: () => canvasRef.current,
		}));

		useEffect(() => {
			if (socket.connected && meetingId) {
				socket.emit("update_meeting_field", {
					meetingId,
					field: "canvasIncluded",
					value: includeCanvas,
				});
			}
		}, [includeCanvas, meetingId]);

		const toggleInclude = () => setIncludeCanvas((prev) => !prev);

		return (
			<>
				<div className="flex items-center space-x-2 py-6">
					<input
						type="checkbox"
						id="includeCanvas"
						checked={includeCanvas}
						onChange={toggleInclude}
						className="w-4 h-4"
					/>
					<label htmlFor="includeCanvas" className="font-bold text-black">
						Adjuntar nota (Canvas)
					</label>
				</div>

				{includeCanvas && (
					<DrawingCanvas
						canvasRef={canvasRef}
						meetingId={meetingId}
						remoteLines={remoteLines}
						setRemoteLines={setRemoteLines}
					/>
				)}
			</>
		);
	}
);

export default CanvasUploader;
